import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getUnApprovedCustomers,
    UnApprovedCustomersModel,
    UnApprovedCustomersParameter,
} from "@tSurya/Services/SurUnApprovedCustomersListService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<UnApprovedCustomersParameter, UnApprovedCustomersModel>;

export const DispatchBeginUnApprovedCustomers: HandlerType = props => {
    props.dispatch({
        type: "Custom/UnApprovedCustomers/BeginLoadUnApprovedCustomers",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getUnApprovedCustomers(props.apiParameter);
};

export const DispatchCompleteUnApprovedCustomers: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/UnApprovedCustomers/CompletedLoadUnApprovedCustomers",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginUnApprovedCustomers,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteUnApprovedCustomers,
];

const loadUnApprovedCustomers = createHandlerChainRunner(chain, "loadUnApprovedCustomers");
export default loadUnApprovedCustomers;
